import type { HTMLAttributes, ReactNode } from 'react';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  size?: 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl';
  color?: 'pink' | 'cyan' | 'yellow' | 'green' | 'white';
  children: ReactNode;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
  sm: 'text-xs', base: 'text-sm', lg: 'text-base',
  xl: 'text-xl', '2xl': 'text-2xl', '3xl': 'text-3xl',
};
const COLOR: Record<NonNullable<Props['color']>, string> = {
  pink: 'text-neon-pink', cyan: 'text-neon-cyan',
  yellow: 'text-neon-yellow', green: 'text-neon-green',
  white: 'text-white',
};

export function PixelText({ size = 'base', color = 'white', className = '', children, ...rest }: Props) {
  return (
    <span className={`pixel-text ${SIZE[size]} ${COLOR[color]} ${className}`} {...rest}>
      {children}
    </span>
  );
}
